<template>
    <div class="view view__session_summary">
        <template v-if="allow">
            <session-summary/>
        </template>
        <pop-notify
            ref="popNotify"
            :class="'pop__notify--redirect'"
            @emit-submit="redirect"
        />
    </div>
</template>

<script>

import SessionSummary from '@/components/ebs/sessions/summary/SessionSummary'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'
import { allowRedirectBeforeRouteLeave } from '@/helpers/mixins'

export default {
  components: {
    PopNotify,
    SessionSummary },
  name: 'view-session-summary',
  mixins: [allowRedirectBeforeRouteLeave],
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData)
    }
  },
  computed: {
    routeSessionId () {
      return this.$route.params.sessionId
    },
    sessionId: function () {
      return this.$store.getters.getSessionId
    },
    sessionTrainers: function () {
      return this.$store.getters.getSessionTrainers
    },
    sessionCompletionEnableRegisters: function () {
      return this.$store.getters['getSessionCompletionEnableRegisters']
    },
    sessionCompletionType: function () {
      return this.$store.getters['getSessionCompletionType']
    },
    //
    summaryId: function () {
      return this.$store.getters.getSummaryId
    },
    summarySessionId: function () {
      return this.$store.getters.getSummarySessionId
    },
    summaryStatus: function () {
      return this.$store.getters.getSummaryStatus
    },
    //
    allow: function () {
      if (!this.sessionId) return true
      if (!(this.user.isEventCoordinator() || this.user.isSessionTrainer(this.sessionTrainers))) return false
      if (!this.sessionCompletionType === 'assessment') return false
      if (this.summaryStatus === 'not_available') {
        return this.$route.name === 'ebs-session-summary-print'
      }
      return true
    },
    //
    watchComputedReload () {
      return this.routeSessionId + this.summaryId + this.sessionId
    },
    watchComputedStopLoading () {
      return this.summaryId + this.sessionId
    }
  },
  watch: {
    allow: function (value) {
      if (value) return
      this.redirectNotAllowed()
    },
    //
    watchComputedReload: function (value) {
      if (this.summarySessionId === '' || (this.summarySessionId !== null && !(this.summarySessionId === this.routeSessionId))) {
        this.getSession()
      }
      if (this.summaryId === '' || this.summarySessionId === '') {
        this.$eventBus.$emit('start-loading')
      }
    },
    //
    watchComputedStopLoading: function () {
      if (this.summaryId !== '' && this.sessionId !== '') {
        this.$eventBus.$emit('stop-loading')
      }
    }
  },
  methods: {
    redirectNotAllowed: function () {
      if (!this.allow) {
        this.allowRedirect()
        this.$router.push({ name: '404' })
      }
    },
    //
    getSummary: function () {
      const sessionId = this.$route.params.sessionId
      this.$store.dispatch('getSummary', sessionId)
    },
    getSession: function () {
      const sessionId = this.$route.params.sessionId
      this.$store.dispatch('getSession', sessionId)
    }
  },
  created () {
    this.getSummary()
    this.getSession()
  },
  mounted () {
    this.$eventBus.$on('ebs-session-summary-submit', this.allowRedirect)
    if (this.summaryId === '' || this.summarySessionId === '') {
      this.$eventBus.$emit('start-loading')
    }
  },
  beforeDestroy () {
    this.$store.dispatch('resetSummary')
    this.$eventBus.$off('ebs-session-summary-submit')
  }
}
</script>
